import * as React from "react";

import {
  GenericFormConsumerInterface,
  GenericReactProviderFormInterfaceOutput,
  useForm,
} from "../../hooks";

import {
  OneTimePasswordFormApp_SendCode,
  OneTimePasswordFormInitialState_SendCode,
  OneTimePasswordFormLogic_SendCode,
  OneTimePasswordForm_SendCode,
} from "./one-time-password-send-code-form";

interface OneTimePasswordSendCodeFormConsumerInterface
  extends GenericFormConsumerInterface<OneTimePasswordForm_SendCode> {
  isSendCodeFormCompleteAndValid: () => boolean;
}
const defaultValue =
  {} as unknown as OneTimePasswordSendCodeFormConsumerInterface;
const OneTimePasswordSendCodeFormContext = React.createContext(defaultValue);

interface OneTimePasswordSendCodeForm_ControllerConsumerInterface {
  resetForm: () => void;
}
const defaultControllerValue =
  {} as unknown as OneTimePasswordSendCodeForm_ControllerConsumerInterface;
const OneTimePasswordSendCodeForm_ControllerContext = React.createContext(
  defaultControllerValue
);

export const OneTimePasswordSendCodeFormProvider: React.FunctionComponent = (
  props
) => {
  const form = useForm<
    OneTimePasswordForm_SendCode,
    OneTimePasswordFormApp_SendCode
  >(
    OneTimePasswordFormLogic_SendCode,
    () => ({}),
    OneTimePasswordFormInitialState_SendCode
  );

  const isSendCodeFormCompleteAndValid = React.useCallback(() => {
    return form.validateRightNowAndGiveMeAYesOrNo();
  }, [form]);

  const value: OneTimePasswordSendCodeFormConsumerInterface = React.useMemo(
    () => ({
      ...GenericReactProviderFormInterfaceOutput(form),
      isSendCodeFormCompleteAndValid,
    }),
    [form, isSendCodeFormCompleteAndValid]
  );
  const controllerValue: OneTimePasswordSendCodeForm_ControllerConsumerInterface =
    React.useMemo(
      () => ({
        resetForm: form.resetForm,
      }),
      [form]
    );
  return (
    <OneTimePasswordSendCodeFormContext.Provider value={value}>
      <OneTimePasswordSendCodeForm_ControllerContext.Provider
        value={controllerValue}
      >
        {props.children || []}
      </OneTimePasswordSendCodeForm_ControllerContext.Provider>
    </OneTimePasswordSendCodeFormContext.Provider>
  );
};

export const useOneTimePasswordSendCodeForm = () => {
  const context = React.useContext(OneTimePasswordSendCodeFormContext);
  if (context === defaultValue) {
    throw new Error(
      "useOneTimePasswordSendCodeForm must be used within a OneTimePasswordSendCodeFormProvider"
    );
  }
  return context;
};

export const useOneTimePasswordSendCodeForm_asController = () => {
  const context = React.useContext(
    OneTimePasswordSendCodeForm_ControllerContext
  );
  if (context === defaultControllerValue) {
    throw new Error(
      "useOneTimePasswordSendCodeForm_asController must be used within a OneTimePasswordSendCodeFormProvider"
    );
  }
  return context;
};
